<!-- login form -->
<div class="text-center w-full">
  <form class="text-center w-full max-w-sm my-10 space-y-6 inline-block " [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="text-center w-full">
      <p><img class="m-auto w-35" alt="logo OPVS GROUP" src="/assets/images/Logo_OPVS_GROUP.jpg"></p>
      <h2 class=" text-center mb-1 text-3xl font-semibold">Benvenuto !</h2>
      <p class="text-sm text-muted-foreground">Inserisci le credenziali ed accedi.</p>
    </div>
    <div
      class="my-4 flex items-center before:mt-0.5 before:flex-1 before:border-t before:border-muted after:mt-0.5 after:flex-1 after:border-t after:border-muted">
    </div>
    <div class="form__group">
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="email">
            Email
          </label>
        </div>
        <div class="md:w-2/3">
          <input type="text" id="email" [ngClass]="{ 'is__invalid-input': submitted && f['email'].errors }"
          placeholder=" " formControlName="email"
            class="bg-gray-50 appearance-none border-2 border-primary-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
            placeholder="inserisci l'e-mail" formControlName="email"
            autocomplete="shipping username">
        </div>
        <div *ngIf="submitted && f['email'].errors" class="is__invalid-error">
          <div *ngIf="f['email'].errors['required']">Campo richiesto</div>
          <div *ngIf="f['email'].errors['email']">L'e-mail deve essere un indirizzo valido.</div>
        </div>
      </div>
    </div>
    <div class="form__group">
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="password">
            Password
          </label>
        </div>
        <div class="md:w-2/3">
          <input
          [type]="passwordTextType ? 'text' : 'password'" id="password"
          [ngClass]="{ 'is__invalid-input': submitted && f['email'].errors }" placeholder="Inserisci la password"
          formControlName="password"
            class="bg-gray-50 appearance-none border-2 border-primary-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
            autocomplete="shipping current-password">
        </div>
        <!-- button routerLink="/auth/forgot-password" impact="none" tone="primary" shape="rounded" size="small">
      Forgot your password?
    </button -->
      </div>
    </div>
    <div class="text-center w-full md:items-center">
      <button impact="bold" tone="primary" shape="rounded" size="medium" class="shadow focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded">
        Entra
      </button>
    </div>
  </form>
</div>
